export default class DeviceUtils {
	static isMobile(): boolean {
		return bowser.mobile
	}
}
